<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="container-fluid">
  <h6  class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/admin/overview"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/aparment/index"> Apartment List </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{ customers.apt_no}}  </h6>

  <h6 class="custom-maintitle mb-2"><b>{{ customers.apt_no}}</b></h6>

  <div   class="d-grid gap-2 d-md-flex justify-content-md-end">

<button   class="btn custom-btn btn-primary btn-sm mb-1 font-size_def">History</button>
<button @click="updateLoad(customers.idCustomer)" class="btn custom-btn btn-primary btn-sm mb-1 font-size_def"> Update</button>



</div>



<div class="card mt-1">
<div class="card-body">


    <table style="font-size: small; " class="table table-striped table-sm table-hover ">
       
          <tbody>

            <tr>
              <td class="width-custom2"><b>Id </b></td>
             <td>{{ customers.idCustomer}}</td> 
            </tr>
            <tr>
              <td><b>Apt No </b></td>
             <td>{{ customers.apt_no}}</td> 
            </tr>
            <tr>
              <td><b>Name of Homeowner </b></td>
             <td>{{ customers.C_name}}</td> 
            </tr>
            <tr>
              <td><b>Address Line 1 </b></td>
             <td>{{ customers.C_address_line1}}</td> 
            </tr>
           
            <tr>
              <td><b>Address Line 2 </b></td>
             <td>{{ customers.C_address_line2}}</td> 
            </tr>
            <tr>
              <td><b>Address Line 3 </b></td>
             <td>{{ customers.C_address_line3}}</td> 
            </tr>
            <tr>
              <td><b>Apt Phone</b></td>
             <td>{{ customers.C_contact_tel1}}</td> 
            </tr>
            <tr>
              <td><b>Service charge/<br> Sinking fund </b></td>
             <td>{{ customers.billing_type}}</td> 
            </tr>
            <tr>
              <td><b>Created Date </b></td>
             <td>{{ customers.C_created_date}}</td> 
            </tr>
           
             
          </tbody>


        </table>
       


<br>
    <h6 class="purchitem mb-2"><b>Homeowner Contact List</b></h6>
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead>
          <tr>
           
                <th>   
                  <div class="form-group custom-form ">
                    <label class="custom-label">Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Tel.</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label ">Actions</label>
                  </div>
                </th>
                
                
              
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="(customer_contact, index) in customer_contacts" :key="customer_contact.id">
             
              <td>{{customer_contact.name}} </td>
              <td>{{customer_contact.email }}</td>
              <td>{{customer_contact.tel }}</td>
              <td class="width-custom5">
                <button   class="btn me-1 custom-btn btn-primary btn-sm mb-1 font-size_def">Inactive</button>
                <button @click="contactUpdate(customer_contact.id)"  class="btn custom-btn btn-primary btn-sm mb-1 font-size_def"> Update</button>
              </td>
             
              
              
            </tr>
           
           



          
            
          </tbody>


        </table>
       
    </div>

<br>
    <h6 class="purchitem mb-2"><b>Tenant Contact List</b></h6>
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead>
          <tr>
           
                <th>   
                  <div class="form-group custom-form ">
                    <label class="custom-label">Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Tel.</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label ">Actions</label>
                  </div>
                </th>
                
                
              
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tenant, index) in tenants" :key="tenant.id">
             
              <td>{{tenant.tenant_name}} </td>
              <td>{{ }}</td>
              <td>{{tenant.contact }}</td>
              <td class="width-custom5">
                <button   class="btn me-1 custom-btn btn-primary btn-sm mb-1 font-size_def">Inactive</button>
                <button @click="tenantUpdate(tenant.id)" class="btn custom-btn btn-primary btn-sm mb-1 font-size_def"> Update</button>
              </td>
             
              
              
            </tr>
           
           



          
            
          </tbody>


        </table>
       
    </div>


    
<br>
    <h6 class="purchitem mb-1"><b>Occupants</b></h6>
   
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        
          <tbody>
            <tr>
              <td class="width-custom2"><b>Number of Occupants </b></td>
             <td>{{ customers.C_occupants}}</td> 
             <td class="width-custom6" >
                <button  @click="occupantsUpdate(customers.idCustomer)"  class=" btn custom-btn btn-primary btn-sm ">Update</button>
            </td> 
            </tr>
           
           



          
            
          </tbody>


        </table>
       
    </div>
    
    

    <div style="border-bottom: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
   
    </div>




</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
       
        'idCustomer':this.$route.query.id,
        
        customers:{},
        customer_contacts:[],
        tenants:[],
       
      


        
      }

    },
    mounted(){
 
  this.loadApartment();
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  updateLoad(id){
    this.$router.push('/aparment/update?id='+id);
  },
  contactUpdate(id){
    this.$router.push('/contact/update?id='+id);
  },
  tenantUpdate(id){
    this.$router.push('/tenant/update?id='+id);
  },
  occupantsUpdate(id){
    this.$router.push('/occupant/update?id='+id);
  },

      


  
  
  async loadApartment() {
    console.log(this.idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+this.idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.customers = data.customer;
       this.customer_contacts = data.customer_contact;
       this.tenants = data.tenant;
      
    } catch (error) {
      console.log(error.response);
    }
  },




},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>